import { render, staticRenderFns } from "./ReportPerformanceThresholds.vue?vue&type=template&id=22a050e6&scoped=true"
import script from "./ReportPerformanceThresholds.vue?vue&type=script&lang=js"
export * from "./ReportPerformanceThresholds.vue?vue&type=script&lang=js"
import style0 from "./ReportPerformanceThresholds.vue?vue&type=style&index=0&id=22a050e6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a050e6",
  null
  
)

export default component.exports